import React from 'react';
import styled from 'styled-components';

import useTranslation from 'hooks/use-translation';

import { ModalExitIcon, ModalFooter } from 'components/core';
import { ModalContent, HeaderText, ModalFooterText, SignUpText as TermsText } from 'components/modals/components';
import { MobileEcommTermsLink } from 'src/mobile-ecomm/components/terms-link';
import SignUpForm from 'components/forms/sign-up-form';
import useUI from 'src/hooks/use-ui';

export type SignupModalContentProps = {
  onClose: () => void;
};

export function SignupModalContent({ onClose }: SignupModalContentProps): JSX.Element {
  const { t } = useTranslation();

  const UI = useUI();
  const { isMobileEcommApp } = UI;

  return (
    <>
      <ModalExitIcon onClick={onClose} />
      <ModalContent pb={isMobileEcommApp ? 30 : 92}>
        <HeaderText pt={26} mb={25} mt={0}>
          {t('signUpModal.headerText', 'Create an Account')}
        </HeaderText>
        <SignUpForm onClose={onClose} />
      </ModalContent>
      <ModalFooter>
        <ModalFooterText xSmall>
          {isMobileEcommApp
            ? t('signUpModal.footerText', `By creating an account, you agree to our`)
            : t('signUpModal.footerText', `By creating an account, you agree to Dutchie's`)}
        </ModalFooterText>
        <StyledTermsText xSmall isMobileEcommApp>
          {isMobileEcommApp ? (
            <MobileEcommTermsLink text={t('signUpModal.terms', 'Terms')} />
          ) : (
            <a href='/terms' target='_blank' rel='noopener noreferrer'>
              {t('signUpModal.terms', 'Terms')}
            </a>
          )}
        </StyledTermsText>
      </ModalFooter>
    </>
  );
}

const StyledTermsText = styled(TermsText)`
  margin-left: 0px;
  padding-left: ${({ isMobileEcommApp }) => (isMobileEcommApp ? '3px' : '5px')};
`;
